import { Component, OnInit, Compiler } from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { CommonService } from '../service/commons-service';
import { Common } from '../util/common';
import { ExcelService } from '../service/excel.service';

@Component({
  templateUrl: 'scoreComputation.component.html',
  styleUrls: ['scoreComputation.component.css'],
})
export class ScoreComputationComponent implements OnInit {
  users: any = {};
  config: any;
  loading = false;
  userList: any[] = [];
  userFunSkillList: any[] = [];
  userFunSkillRatingList: any[] = [];
  userSkillRatingData: any[] = [];
  loginImageURL: any = '';
  baseURL: any = null;
  loginUserName: any = '';
  skillList: any[] = [];
  behSkillList: any[] = [];
  userBehSkillRatingList: any[] = [];
  selectedPositionId: Number = 0;
  selectedCombinedId: any;
  userBehSkillList: any[] = [];
  skillRatingList: any[] = [];
  selectedUserId: any = 'Select User';
  inactiveUserCount = 0;
  activeUserCount = 0;
  functionalActive = '';
  behavioralActive = '';
  selectedType: any = '';
  isSkillDataPresent: any = true;
  nextPosition: any = '';
  currentPositionName: any = '';
  nextPositionName: any = '';
  nextPositionId: any = '';

  positionList: any = [];

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private excelService: ExcelService,
    private commonService: CommonService,

    private common: Common,
    private appConfig: AppConfig,
    config: NgbDatepickerConfig,
    private _compiler: Compiler
  ) {
    this._compiler.clearCache();
    this.users = JSON.parse(localStorage.getItem('user'));
    if (!this.users || !this.users.userData) {
      this.commonService.logout();
      return;
    }
    if (this.users && this.users.userData) {
      this.users = this.users.userData;

      this.loginUserName = this.users.userFullName;
    }
    let currentDate = new Date();
    this.config = config;
    this.config.minDate = {
      year: currentDate.getFullYear() - 10,
      month: currentDate.getMonth(),
      day: currentDate.getDate(),
    };
    this.config.maxDate = { year: 2099, month: 12, day: 31 };
    this.config.markDisabled = false;
    this.loginImageURL = this.appConfig.getDefaultImgURL();
  }

  ngOnInit() {
    this.getSkillDetails();
    this.getAllBehSkills();
    this.getUsersList();
    this.getSkillRatingDetails();
    this.fetchPositions();
  }

  // Get Skill Details From Skill Master
  private getSkillDetails() {
    this.loading = true;
    this.commonService
      .postAllFunSkills(
        JSON.parse(localStorage.getItem('user')).userData.towerId
      )
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          if (data && data.length > 0) {
            this.skillList = data;
          } else {
            this.loading = false;
            localStorage.setItem('errorMsg', 'Competencies Data Not Found');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // Get Behavioral Skill Details From Skill Master
  private getAllBehSkills() {
    this.loading = true;
    this.commonService
      .postAllBehSkills(
        JSON.parse(localStorage.getItem('user')).userData.towerId
      )
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          if (data && data.length > 0) {
            this.behSkillList = data;
          } else {
            this.loading = false;
            localStorage.setItem(
              'errorMsg',
              'Behavioral Skills Data Not Found'
            );
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // Get Skill Details From Skill Master
  private getSkillRatingDetails() {
    this.loading = true;
    this.commonService
      .fetchSkillRatingData()
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          if (data && data.length > 0) {
            this.skillRatingList = data;
          } else {
            localStorage.setItem(
              'errorMsg',
              'Competencies Rating Data Not Found'
            );
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // /Get All Users information
  private getUsersList() {
    this.loading = true;
    var userEmail = '';
    if (JSON.parse(localStorage.getItem('user')).userData.userRoll == 4)
      userEmail = JSON.parse(localStorage.getItem('user')).userData.userEmail;

    this.commonService
      .getUsersListByPost(
        JSON.parse(localStorage.getItem('user')).userData.towerId,
        userEmail
      )
      .subscribe(
        (data) => {
          this.loading = false;
          if (data && data.length > 0) {
            this.userList = data;
          } else {
            localStorage.setItem('errorMsg', 'Users Not Found');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // Get All Users information
  private getNextPosition() {
    this.loading = true;
    this.isSkillDataPresent = false;
    this.functionalActive = '';
    this.behavioralActive = '';
    if (this.selectedCombinedId.split('_')[0] == '') return;

    var currentUserId = this.selectedCombinedId.split('_')[0];
    for (let i = 0; i < this.userList.length; i++) {
      if (currentUserId == this.userList[i].userId) {
        this.currentPositionName = this.userList[i].positionName;
        this.nextPositionId = this.userList[i].nextPosition;
      }
    }

    console.log('cur level', this.selectedCombinedId.split('_')[0]);
    var towerId = JSON.parse(localStorage.user).userData.towerId;
    this.commonService
      .getNextPosition(this.selectedCombinedId.split('_')[0])
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          console.log('returneed data', data);
          if (data && data.length > 0) {
            console.log(data);
            this.nextPosition = data[0].positionName;
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private getPositionName(positionId) {
    for (let i = 0; i < this.positionList.length; i++) {
      if (this.positionList[i].positionId == positionId)
        return this.positionList[i].positionName;
    }
  }

  // /fetch user information data
  private fetchPositions() {
    //var towerId = JSON.parse(localStorage.user).userData.towerId;
    this.commonService
      .getAllPositionInfo(null)
      .pipe(first())
      .subscribe(
        (data) => {
          this.positionList = data;
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private getUserFunSkillRatingInfo() {
    this.selectedUserId = this.selectedCombinedId.split('_')[0];
    this.selectedPositionId = this.selectedCombinedId.split('_')[1];
    let userNextPositionId = this.selectedCombinedId.split('_')[2];
    let selectedUserTowerId = this.selectedCombinedId.split('_')[3];
    this.nextPositionId = userNextPositionId;

    if (!this.selectedUserId || this.selectedUserId == 'Select User') {
      localStorage.setItem('errorMsg', 'Please select user first!');
      this.commonService.showerror();
      localStorage.removeItem('errorMsg');
      return;
    }
    this.loading = true;
    let userIds = [Number(this.selectedUserId)];
    var userId: any = Number(this.selectedUserId);
    this.userSkillRatingData = [];

    this.functionalActive = 'active';
    this.behavioralActive = '';
    const towerId = JSON.parse(localStorage.getItem('user')).userData.towerId
      ? JSON.parse(localStorage.getItem('user')).userData.towerId
      : selectedUserTowerId;
    this.commonService
      .getUserFunSkillRatingInfo(userId, undefined, this.nextPositionId)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data.length > 0) {
            this.isSkillDataPresent = true;
            this.userFunSkillRatingList = data;
            console.log(
              'this.userFunSkillRatingList',
              this.userFunSkillRatingList
            );
            this.filterFuncomputeScoreList();
            // this.filterScoreComputation(true);
          } else {
            this.loading = false;
            this.isSkillDataPresent = false;
            localStorage.setItem('errorMsg', 'User skill rating not found');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          this.isSkillDataPresent = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //Get user skills data
  private getUserBehSkillRatingInfo() {
    this.selectedUserId = this.selectedCombinedId.split('_')[0];
    this.selectedPositionId = this.selectedCombinedId.split('_')[1];
    let userNextPositionId = this.selectedCombinedId.split('_')[2];
    let selectedUserTowerId = this.selectedCombinedId.split('_')[3];
    this.nextPositionId = userNextPositionId;
    if (!this.selectedUserId || this.selectedUserId == 'Select User') {
      localStorage.setItem('errorMsg', 'Please select user first!');
      this.commonService.showerror();
      localStorage.removeItem('errorMsg');
      return;
    }
    this.loading = true;
    let userIds = [Number(this.selectedUserId)];
    var userId: any = Number(this.selectedUserId);
    this.userSkillRatingData = [];
    this.functionalActive = '';
    this.behavioralActive = 'active';
    // this.nextPositionId
    const towerId = JSON.parse(localStorage.getItem('user')).userData.towerId
      ? JSON.parse(localStorage.getItem('user')).userData.towerId
      : selectedUserTowerId;
    console.log(
      'Compute Score',
      userId,
      JSON.parse(localStorage.getItem('user')).userData.towerId,
      userNextPositionId
    );
    this.commonService
      .getUserBehSkillRatingInfo(userId, undefined, userNextPositionId)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data.length > 0) {
            this.isSkillDataPresent = true;
            console.log('data', data);
            this.userBehSkillRatingList = data;
            this.filterBehComputeScoreList();

            // this.filterScoreComputation(false);
          } else {
            this.loading = false;
            this.isSkillDataPresent = false;
            localStorage.setItem('errorMsg', 'User skill rating not found');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          this.isSkillDataPresent = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  /**
   * Filter Beh. Compute Score List.
   */
  filterBehComputeScoreList() {
    console.log(
      'Compute: this.userBehSkillRatingList',
      this.userBehSkillRatingList
    );
    this.selectedType = 'Beh';
    for (let j = 0; j < this.userBehSkillRatingList.length; j++) {
      let skillRatingObj = {};
      skillRatingObj['skillId'] = this.userBehSkillRatingList[j].skillId;
      skillRatingObj['skillName'] = this.userBehSkillRatingList[j].skillName;
      skillRatingObj['targetScore'] =
        this.userBehSkillRatingList[j].targetScore;
      if (
        this.userBehSkillRatingList[j] &&
        this.userBehSkillRatingList[j].skillScore &&
        this.userBehSkillRatingList[j].ratedByRole == 4
      ) {
        skillRatingObj['managerRating'] =
          this.userBehSkillRatingList[j].skillScore;
      } else if (
        this.userBehSkillRatingList[j] &&
        this.userBehSkillRatingList[j].skillScore &&
        this.userBehSkillRatingList[j].ratedByRole == 5
      ) {
        skillRatingObj['selfRating'] =
          this.userBehSkillRatingList[j].skillScore;
      }
      const index = this.userSkillRatingData.findIndex(
        (item) => item.skillId == this.userBehSkillRatingList[j].skillId
      );
      if (index != -1 && this.userBehSkillRatingList[j].ratedByRole == 4) {
        this.userSkillRatingData[index].managerRating =
          this.userBehSkillRatingList[j].skillScore;
      } else if (
        index != -1 &&
        this.userBehSkillRatingList[j].ratedByRole == 5
      ) {
        this.userSkillRatingData[index].selfRating =
          this.userBehSkillRatingList[j].skillScore;
      } else {
        this.userSkillRatingData.push(skillRatingObj);
      }
    }
    this.loading = false;
    return;
  }
  /**
   * Filter Functional Compute Score List.
   */
  filterFuncomputeScoreList() {
    this.selectedType = 'Fun';

    for (let j = 0; j < this.userFunSkillRatingList.length; j++) {
      let skillRatingObj = {};
      skillRatingObj['skillId'] = this.userFunSkillRatingList[j].skillId;
      skillRatingObj['skillName'] = this.userFunSkillRatingList[j].skillName;
      skillRatingObj['targetScore'] =
        this.userFunSkillRatingList[j].targetScore;
      if (
        this.userFunSkillRatingList[j] &&
        this.userFunSkillRatingList[j].skillScore &&
        this.userFunSkillRatingList[j].ratedByRole == 4
      ) {
        skillRatingObj['managerRating'] =
          this.userFunSkillRatingList[j].skillScore;
      } else if (
        this.userFunSkillRatingList[j] &&
        this.userFunSkillRatingList[j].skillScore &&
        this.userFunSkillRatingList[j].ratedByRole == 5
      ) {
        skillRatingObj['selfRating'] =
          this.userFunSkillRatingList[j].skillScore;
      }
      const index = this.userSkillRatingData.findIndex(
        (item) => item.skillId == this.userFunSkillRatingList[j].skillId
      );
      if (index != -1 && this.userFunSkillRatingList[j].ratedByRole == 4) {
        this.userSkillRatingData[index].managerRating =
          this.userFunSkillRatingList[j].skillScore;
      } else if (
        index != -1 &&
        this.userFunSkillRatingList[j].ratedByRole == 5
      ) {
        this.userSkillRatingData[index].selfRating =
          this.userFunSkillRatingList[j].skillScore;
      } else {
        this.userSkillRatingData.push(skillRatingObj);
      }
    }
    this.loading = false;
    return;
  }
  // filter user skill score computation
  private filterScoreComputation(isFunctional) {
    if (isFunctional) this.selectedType = 'Fun';
    else this.selectedType = 'Beh';
    console.log('SKILL LIST', this.skillList);
    console.log(
      'this.userBehSkillRatingList.length',
      this.userBehSkillRatingList.length
    );
    this.userSkillRatingData = [];
    if (isFunctional) {
      if (this.skillList && this.skillList.length > 0) {
        for (let i = 0; i < this.skillList.length; i++) {
          if (this.skillList[i].positionId != this.nextPositionId) continue;

          let skillRatingObj = {};
          skillRatingObj['skillId'] = this.skillList[i].skillId;
          skillRatingObj['skillName'] = this.skillList[i].skillName;
          skillRatingObj['targetScore'] = this.skillList[i].targetScore;
          // set self and manager ratings
          for (let j = 0; j < this.userFunSkillRatingList.length; j++) {
            if (
              this.skillList[i].skillId ==
                this.userFunSkillRatingList[j].skillId &&
              this.userFunSkillRatingList[j].ratedByRole == 4
            ) {
              if (
                this.userFunSkillRatingList[j] &&
                this.userFunSkillRatingList[j].skillScore
              ) {
                skillRatingObj['managerRating'] =
                  this.userFunSkillRatingList[j].skillScore;
              }
            } else if (
              this.skillList[i].skillId ==
                this.userFunSkillRatingList[j].skillId &&
              this.userFunSkillRatingList[j].ratedByRole == 5
            ) {
              if (
                this.userFunSkillRatingList[j] &&
                this.userFunSkillRatingList[j].skillScore
              ) {
                skillRatingObj['selfRating'] =
                  this.userFunSkillRatingList[j].skillScore;
              }
            }
          }

          if (!skillRatingObj['managerRating']) {
            skillRatingObj['managerRating'] = 0;
          }

          if (!skillRatingObj['selfRating']) {
            skillRatingObj['selfRating'] = 0;
          }
          this.userSkillRatingData.push(skillRatingObj);
        }
      }
    } else {
      if (this.behSkillList && this.behSkillList.length > 0) {
        for (let i = 0; i < this.behSkillList.length; i++) {
          if (this.behSkillList[i].positionId != this.nextPositionId) continue;
          let skillRatingObj = {};
          skillRatingObj['skillId'] = this.behSkillList[i].skillId;
          skillRatingObj['skillName'] = this.behSkillList[i].skillName;
          skillRatingObj['targetScore'] = this.behSkillList[i].targetScore;

          for (let j = 0; j < this.userBehSkillRatingList.length; j++) {
            if (
              this.behSkillList[i].skillId ==
                this.userBehSkillRatingList[j].skillId &&
              this.userBehSkillRatingList[j].ratedByRole == 4
            ) {
              if (
                this.userBehSkillRatingList[j] &&
                this.userBehSkillRatingList[j].skillScore
              ) {
                skillRatingObj['managerRating'] =
                  this.userBehSkillRatingList[j].skillScore;
              }
            } else if (
              this.behSkillList[i].skillId ==
                this.userBehSkillRatingList[j].skillId &&
              this.userBehSkillRatingList[j].ratedByRole == 5
            ) {
              if (
                this.userBehSkillRatingList[j] &&
                this.userBehSkillRatingList[j].skillScore
              ) {
                skillRatingObj['selfRating'] =
                  this.userBehSkillRatingList[j].skillScore;
              }
            }
          }

          if (!skillRatingObj['managerRating']) {
            skillRatingObj['managerRating'] = 0;
          }

          if (!skillRatingObj['selfRating']) {
            skillRatingObj['selfRating'] = 0;
          }

          this.userSkillRatingData.push(skillRatingObj);
        }
      }
    }

    console.log('userSkillRatingData', this.userSkillRatingData);
    this.loading = false;
    return;
  }

  private getSkillScore(SkillName) {
    let score = 0;
    if (this.skillRatingList && this.skillRatingList.length > 0) {
      for (let i = 0; i < this.skillRatingList.length; i++) {
        if (this.skillRatingList[i].ratingName == SkillName) {
          score = this.skillRatingList[i].score;
          break;
        }
      }
    }
    return score;
  }

  //Validate skill rating score data
  private validateSkillratingScoreData(skillScore) {
    if (!skillScore || skillScore == '') {
      return 0;
    }
    return skillScore;
  }

  //export resource history data
  private excelReport() {
    let excelExportData = [];
    let headers = [
      'S.No.',
      'Employee Name',
      'TR Nominee Type',
      'Joining Date',
      'Leaving Date',
      'Team',
      'Email',
      'Created By',
      'HTML Level',
      'Lectora Level',
      'StoryLine Level',
    ];
    for (let i = 0; i < this.userList.length; i++) {
      let data = {};
      data[headers[0]] = i + 1;
      data[headers[1]] = this.userList[i].userName;
      data[headers[2]] = this.userList[i].typeResource;
      data[headers[3]] = new Date(this.userList[i].joinDate);
      data[headers[5]] = new Date(this.userList[i].leaveDate);
      data[headers[6]] = this.userList[i].team;
      data[headers[7]] = this.userList[i].email;
      data[headers[8]] = this.userList[i].createdByEmail;
      data[headers[9]] = this.userList[i].createdByEmail;
      data[headers[10]] = this.replaceSkillName(
        this.userList[i].userSkill[2].skillLevel
      );
      data[headers[11]] = this.replaceSkillName(
        this.userList[i].userSkill[1].skillLevel
      );
      data[headers[12]] = this.replaceSkillName(
        this.userList[i].userSkill[0].skillLevel
      );
      excelExportData.push(data);
    }
    this.excelService.generateExcel(headers, excelExportData, 'UserList');
  }

  //replace numbric value from skill name
  private replaceSkillName(skillName) {
    if (skillName) {
      skillName = skillName.replace('1_', '');
      skillName = skillName.replace('2_', '');
      skillName = skillName.replace('3_', '');
    }
    return skillName;
  }

  //forward to next section
  public gotoNextPage(e, routeURL) {
    this.router.navigate([routeURL]);
  }

  // logout and forward to login page
  private logout() {
    this.commonService.logout();
  }
}
